import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6ba2f4fc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=6ba2f4fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2f4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba2f4fc')) {
      api.createRecord('6ba2f4fc', component.options)
    } else {
      api.reload('6ba2f4fc', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6ba2f4fc&scoped=true", function () {
      api.rerender('6ba2f4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/Index.vue"
export default component.exports